import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MainNavbarModule } from 'app/partials/main-navbar/main-navbar.module';
import { RecentBlogArticlesModule } from 'app/partials/recent-blog-articles/recent-blog-articles.module';
import { WipStepsModule } from 'app/partials/wip-steps/wip-steps.module';
import { WipperozServicesModule } from 'app/partials/wipperoz-services/wipperoz-services.module';
import { FooterModule } from '../partials/footer/footer.module';
import { UnsubscribeRoutingModule } from './unsubcribe-routing.module';

import { UnsubscribeComponent } from './unsubscribe.component';

@NgModule({
  declarations: [UnsubscribeComponent],
  imports: [
    CommonModule,
    UnsubscribeRoutingModule,
    FooterModule,
    MainNavbarModule,
    RecentBlogArticlesModule,
    WipperozServicesModule,
    WipStepsModule
  ],
  exports: []
})
export class UnsubscribeModule {}
